import { render, staticRenderFns } from "./MembershipCardTemplateBuilder.vue?vue&type=template&id=99d70e84&scoped=true"
import script from "./MembershipCardTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./MembershipCardTemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./MembershipCardTemplateBuilder.vue?vue&type=style&index=0&id=99d70e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d70e84",
  null
  
)

export default component.exports